import {FeatureName} from '@contentlab/types/project';
import translate from '@/utils/translate';

export type FeatureInfo = {
  id: FeatureName;
  title: string;
  isPopular: boolean;
};

const featureMap = () => ({
  [FeatureName.REFORMATTING]: {
    id: FeatureName.REFORMATTING,
    title: translate('Resize to Any\nRatio'),
    description: translate(
      'Crop or expand your video to fit any platform and size'
    ),
    isPopular: true,
  },
  [FeatureName.AI_DUBBING]: {
    id: FeatureName.AI_DUBBING,
    title: translate('Dub into Any\nLanguage'),
    isPopular: false,
  },
  [FeatureName.REPHRASING]: {
    id: FeatureName.REPHRASING,
    title: translate('Rescript\nDialog'),
    isPopular: false,
  },
  [FeatureName.CAPTIONS]: {
    id: FeatureName.CAPTIONS,
    title: translate('Include\nCaptions'),
    isPopular: false,
  },
  [FeatureName.AI_AVATAR]: {
    id: FeatureName.AI_AVATAR,
    title: translate('Design an\nAI Avatar'),
    isPopular: false,
  },
  [FeatureName.UPSCALE]: {
    id: FeatureName.UPSCALE,
    title: translate('Upscale to Any\nResolution'),
    isPopular: false,
  },
});

export default function getFeatureInfo(feature: FeatureName): FeatureInfo {
  return featureMap()[feature];
}
